<template>
  <md-card class="pt-10">
    <md-card-header class="md-card-header-text md-card-header-green pl-2">
      <div class="card-text">
        <p class="title text-lg ">
          {{ $t("assignment_overall.toefl_top_bottom") }}
        </p>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-70">
          <p class="pt-8">
            {{
              $t("assignment_overall.total_student", {
                length: pagination.total
              })
            }}
          </p>
        </div>
        <div class="md-layout-item md-size-30">
          <md-field>
            <md-select
              v-model="selectedTopBottom"
              :name="selectTopBottom.name"
              :id="selectTopBottom.name"
              :multiple="selectTopBottom.multiple"
            >
              <md-option
                v-for="option in selectTopBottom.options"
                :value="option.id"
                :key="option.id + option.name"
                >{{ $t(option.name) }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </div>
      <md-table class="table-top-bottom">
        <md-table-row>
          <md-table-head>
            {{ $t("assignment_overall.student") }}
          </md-table-head>
          <md-table-head>
            {{ $t("assignment_overall.test_date") }}</md-table-head
          >
          <md-table-head>
            {{ $t("assignment_overall.total_score") }}
          </md-table-head>
          <md-table-head> Listening</md-table-head>
          <md-table-head>
            Reading
          </md-table-head>
          <md-table-head>
            Speaking
          </md-table-head>
          <md-table-head>
            Writing
          </md-table-head>
        </md-table-row>
        <md-table-row v-for="(item, index) in data" :key="item + index">
          <md-table-cell
            ><div class="flex items-center w-52" v-if="item.user">
              <img
                :src="item.user.avatar_url"
                class="object-cover rounded-full w-[42px] h-[42px]"
              />
              <div class="text-left pl-4">
                <p class="font-medium">{{ item.user.full_name }}</p>
                <p class="font-medium">{{ item.user.student_code }}</p>
              </div>
            </div>
          </md-table-cell>
          <md-table-cell>{{
            convertDateFromServer(item.test_date, "date")
          }}</md-table-cell>
          <md-table-cell>{{ item.total_score }}</md-table-cell>
          <md-table-cell>{{ item.listening }}</md-table-cell>
          <md-table-cell>{{ item.reading }}</md-table-cell>
          <md-table-cell>{{ item.speaking }}</md-table-cell>
          <md-table-cell>{{ item.writing }}</md-table-cell>
        </md-table-row>
      </md-table>
      <yv-pagination
        :pagination="pagination"
        @changePage="changePage"
      ></yv-pagination>
    </md-card-content>
  </md-card>
</template>
<script>
import { YvPagination } from "@/components/Base";
import { convertDateFromServer } from "../../../../helpers/datetime-helper";

const optionsTopBottom = [
  { name: "Top total score", id: "total_score_top" },
  { name: "Top Listening", id: "listening_top" },
  { name: "Top Reading", id: "reading_top" },
  { name: "Top Speaking", id: "speaking_top" },
  { name: "Top Writing", id: "writing_top" },
  { name: "Bottom Overall", id: "total_score_bottom" },
  { name: "Bottom Listening", id: "listening_bottom" },
  { name: "Bottom Reading", id: "reading_bottom" },
  { name: "Bottom Speaking ", id: "speaking_bottom" },
  { name: "Bottom Writing", id: "writing_bottom" }
];
export default {
  props: ["data", "pagination", "actionSearch"],
  components: { YvPagination },
  data() {
    return {
      params: {},
      selectedTopBottom: "total_score_top",
      selectTopBottom: {
        label: "common.status",
        name: "status__",
        value: "",
        type: "select",
        options: optionsTopBottom
      },
      convertDateFromServer
    };
  },
  watch: {
    selectedTopBottom: function(newVal) {
      this.$emit("changeTopbottom", newVal);
    }
  },
  methods: {
    changePage() {
      this.params.page = this.pagination.currentPage;
      this.params.limit = this.pagination.perPage;
      this.actionSearch.action(this.params);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-top-bottom {
  .md-table-head {
    padding: 12px 8px;
    text-align: center;
    border: 0.5px solid #b8b7b7;
    .md-table-cell {
      border: 0.5px solid #b8b7b7 !important;
    }
  }
  .md-table-cell {
    border: 0.5px solid #b8b7b7 !important;
  }
}
</style>
